import { driver } from 'driver.js'

// Create singleton instance with base config
const driverInstance = driver({
    stagePadding: 0,
    stageRadius: 8,
    popoverOffset: 4,
    overlayOpacity: 0.4,
})

export const getDriver = () => driverInstance
